export default __webpack_public_path__ + "static/media/mariya-georgieva.bdad4f90.jpg";